// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.gradient-text-approval {
    background: linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 26px;
    font-weight: 700;
    width: 35%;
    margin: auto;
    padding: 1rem;
}

.aproval-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    border: 1px solid #ddd;
    margin: auto;
}

.aproval-table thead {
    background: linear-gradient(to right, #3146a1, #0a73b5, #0195d3);
    color: white;
}

.aproval-table th {
    color: white;
    padding: 10px 12px;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    border: 1px solid #4a90e2;
    /* white-space: nowrap; */
}

.aproval-table td {
    /* padding: 8px 12px; */
    border: 1px solid #ddd;
    vertical-align: middle;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
}

@media (max-width: 576px) {
    .aproval-table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
}

.form-actions-approval {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn-approve {
    background: #4CAF50;
    box-shadow: 0 4px 6px rgba(76, 175, 80, 0.5);
    width: 8rem !important;
}

.btn-approve:hover {
    background: #45a049;
    transform: translateY(-2px);
    box-shadow: 0 6px 10px rgba(76, 175, 80, 0.7);
}

.btn-approve img,
.btn-send-back img,
.btn-cancel-approve img {
    width: 1rem;
}

`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ECSManagement/ECSUpdate/EcsUpdate.css"],"names":[],"mappings":";;AAEA;IACI,yEAAyE;IACzE,6BAA6B;IAC7B,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gEAAgE;IAChE,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;IAGI,WAAW;AACf","sourcesContent":["\r\n\r\n.gradient-text-approval {\r\n    background: linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    font-size: 26px;\r\n    font-weight: 700;\r\n    width: 35%;\r\n    margin: auto;\r\n    padding: 1rem;\r\n}\r\n\r\n.aproval-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 13px;\r\n    border: 1px solid #ddd;\r\n    margin: auto;\r\n}\r\n\r\n.aproval-table thead {\r\n    background: linear-gradient(to right, #3146a1, #0a73b5, #0195d3);\r\n    color: white;\r\n}\r\n\r\n.aproval-table th {\r\n    color: white;\r\n    padding: 10px 12px;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    font-size: 12px;\r\n    border: 1px solid #4a90e2;\r\n    /* white-space: nowrap; */\r\n}\r\n\r\n.aproval-table td {\r\n    /* padding: 8px 12px; */\r\n    border: 1px solid #ddd;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .aproval-table {\r\n        display: block;\r\n        overflow-x: auto;\r\n        white-space: nowrap;\r\n    }\r\n}\r\n\r\n.form-actions-approval {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n}\r\n\r\n.btn-approve {\r\n    background: #4CAF50;\r\n    box-shadow: 0 4px 6px rgba(76, 175, 80, 0.5);\r\n    width: 8rem !important;\r\n}\r\n\r\n.btn-approve:hover {\r\n    background: #45a049;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 10px rgba(76, 175, 80, 0.7);\r\n}\r\n\r\n.btn-approve img,\r\n.btn-send-back img,\r\n.btn-cancel-approve img {\r\n    width: 1rem;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
